module.exports = __webpack_amd_options__;



//////////////////
// WEBPACK FOOTER
// (webpack)/buildin/amd-options.js
// module id = 196
// module chunks = 0 1 2 3 4 5 6 8 9 18 22 23 24